import React, {Fragment, useState, useEffect, useRef} from 'react'
import {Carousel, Button} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerContadores from './Imagens/bannerContadores2.jpg'
import ImagemFinanceiro from './Imagens/bannerFinanceiro.jpg'
import ImagemTransito from './Imagens/bannerTransito.jpg'
import ImagemGestao from './Imagens/bannerContadores.jpg'

export default function Carrossel(props){
    return <div>
   
        <Carousel fade pause ={false}>
    <Carousel.Item>
      <img
        className="d-block w-100"
        src={BannerContadores}
        alt="First slide"
      />
      <Carousel.Caption>
        <div>
        <h1>Buscando uma solução de <strong>Coleta de Contadores</strong> eficiênte e competitiva ?</h1>
        <p>Conheça nosso módulo de coleta de contadores e vá além !</p>
        
        </div>
      </Carousel.Caption>
    </Carousel.Item>

    <Carousel.Item>
      <img
        className="d-block w-100"
        src={ImagemGestao}
        alt="Third slide"
      />
  
      <Carousel.Caption>
        <div>
        <h1>Gerencie seus Equipamentos, Contratos, Aberturas de Ordens de Serviço e Pedidos de Suprimento !</h1>
        <p>Tudo isso em uma única plataforma de gestão.</p>
        
        </div>
      </Carousel.Caption>
    </Carousel.Item>


    <Carousel.Item>
      <img
        className="d-block w-100"
        src={ImagemFinanceiro}
        alt="Second slide"
      
      />
  
      <Carousel.Caption className='color-orange' >
        <div>
          <h1>Desperdicio de impressão é um problema para sua empresa ?</h1>
          <p>Nós possuímos um módulo de Bilhetagem de Impressão para isso.</p>
          
        </div>
      </Carousel.Caption>
    </Carousel.Item>
    
{/*
    <Carousel.Item>
      <img
        className="d-block w-100"
        src={ImagemTransito}
        alt="Third slide"
      />
  
      <Carousel.Caption>
        <div>
        <h1>Temos uma solução de Rastreamento de Frota totalmente INTEGRADA !</h1>
        <p>Saiba em tempo real onde cada veículo se encontra e use informações de geolocalização para otimizar sua gestão.</p>
        
        </div>
      </Carousel.Caption>
    </Carousel.Item>

    */}
  </Carousel>
  </div>
}